<template>
  <div>
    <c-modal
        title="Word Verification"
        size="md"
        @close="$emit('close')"
    >
      <validation-observer v-slot="{ invalid, valid, errors, ...rest }" ref="form">
        <form @submit.prevent="applyVerificationCode">
          <div class="modal-body">


            <div class="agenda-footer-form">
              <validation-provider rules="required" vid="verification_code" v-slot="{errors}">
                <c-input
                    size="sm"
                    icon="fa-lock"
                    placeholder="Word Verification"
                    v-model="form.verification_code"
                    :error="errors[0]"
                    help='Please enter the session keyword to verify your attendance'
                />
              </validation-provider>
            </div>

          </div>
          <div class="modal-footer">

            <div class="word-verification-footer">

              <c-button
                uppercase
                fill
                theme="default"
                size="sm"
                icon="fa-close"
                @click="closeMaterialModal"
              >Close
              </c-button>

              <c-button
                uppercase
                fill
                icon="fa-solid fa-paper-plane"
                type="submit"
                theme="primary"
                size="sm"
                :show-indicator="showVerificationIndicator">
                Apply
              </c-button>
            </div>
          </div>
        </form>
      </validation-observer>
    </c-modal>
  </div>

</template>

<script>
import agendaAPI from "../../api/agendaAPI";

export default {
  props: {
    attendeeId: {
      type: Number,
      required: true,
    },
    sessionId: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      showVerificationIndicator: false,
      form: {
        verification_code: '',
      },
    }
  },
  methods: {
    closeMaterialModal() {
      this.$emit('close')
    },
    applyVerificationCode() {
      this.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }

        const data = {
          verification_code: this.form.verification_code
        };

        this.showVerificationIndicator = true;
        agendaAPI.changeVerificationCode(this.attendeeId, this.sessionId, data)
            .then((res) => {
              this.$emit('success', res.data)
              this.$emit('close')
            })
            .catch((err) => {
              if (err.response?.data?.errors) {
                this.$refs.form.setErrors(err.response.data.errors);
              }
            })
            .finally(() => {
              this.showVerificationIndicator = false;
            });

        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.agenda-footer-form {
  //display: flex;
  //gap: 10px;
}

.word-verification-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;

}
</style>
